import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory, Route
} from 'react-router-dom';
import PropTypes from 'prop-types';

import { getOrderSections, getPartsStrings } from 'redux/reducers';
import { SET_LANGUAGE } from 'redux/actions';
import { makeListPDF, makeImagePDF } from 'utils/orderToPDF';
import orderToSheet, { download as downloadSheet } from 'utils/orderToSheet';

import './Header.css';

import logo from './logo.png';

// custom hook for the different menus
const useContextualMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => {
    // close the menu
    setIsOpen(false);
  };

  const onToggleOpenMenu = () => {
    setIsOpen(!isOpen);
  };

  return [isOpen, close, onToggleOpenMenu];
};

// TODO - create HOC called 'ContextualHeaderMenu'
const ShareList = () => {
  const [isOpen, close, onToggleOpenMenu] = useContextualMenu();
  const getString = useSelector(state => state.strings.getString);
  const orderSections = useSelector(state => getOrderSections(state));
  const partsStrings = useSelector(state => getPartsStrings(state));
  const viewOrderImages = useSelector(state => state.preferences.viewOrderImages);

  const generatePDF = () => {
    return viewOrderImages
      ? makeImagePDF(orderSections, getString, partsStrings)
      : makeListPDF(orderSections, getString, partsStrings);
  };

  const generateSheet = () => {
    return orderToSheet(orderSections, getString, partsStrings);
  };

  const onDownloadPDF = async () => {
    const pdf = await generatePDF();
    // To make sure filename is not 'unknown':
    // https://pdfmake.github.io/docs/document-definition-object/document-medatadata/
    pdf.download('draeger-order-list.pdf');
    /*
    pdf.getDataUrl((dataUrl) => {
      navigator.share({
        title: 'draeger-order-list.pdf',
        text: 'some text',
        url: dataUrl
      });
    });
    */
    /*
    navigator.share({
      title: 'draeger-order-list.pdf',
      text: 'some text',
      url: 'https://abiomedtraining.com/ACE/site/public/resources/dataRepository/content/pdfs/000/Impella%20Update%20-%20Best%20Outcomes%20in%20CGS%20Impella%20PrePCI_FR'
    });
    */
    close();
  };

  const onDownloadSheet = () => {
    // this used to be .xlsb - but why?
    downloadSheet(generateSheet(), 'draeger-order-list');

    close();
  };

  const onEmailPDF = () => {
    /*
    const pdf = this.generatePDF();
    // send it to a temp file that can be used as an attachment
    pdf.getBase64(dataUrl => fetch(PDF_ATTACHMENT_URL, {
      body: dataUrl,
      headers: {
        'Content-Type': 'application/pdf; charset=utf-8'
      },
      method: 'POST',
      mode: 'cors'
    }).then(response => response.text())
      .then((response) => {
        console.log(response);
        // window.location.href = `mailto:info@draeger.com?subject=HCA parts list&body=${response}`;
      }));

    this.close();
     */
  };

  const onEmailSheet = () => {

  };

  const dropButtonClass = isOpen ? 'fa-times' : 'fa-bars';
  return (
    <div className="ma-top-right">
      <h2 className="block-head">
        <span className="number">
          5
        </span>
        <span>
          {getString('share-list')}
        </span>
      </h2>
      <button
        className="ma-optns"
        onClick={onToggleOpenMenu}
        type="button"
      >
        <i className={`fa ${dropButtonClass}`} />
      </button>
      <div className="header-menu" style={{ maxHeight: isOpen ? '120px' : 0 }}>
        <button key="download-pdf" onClick={onDownloadPDF} type="button">
          {getString('download-pdf')}
        </button>
        <button key="download-sheet" onClick={onDownloadSheet} type="button">
          {getString('download-sheet')}
        </button>
      </div>
    </div>
  );
};

const setLanguage = languageCode => ({ type: SET_LANGUAGE, languageCode });

const LanguageMenu = () => {
  const [isOpen, close, onToggleOpenMenu] = useContextualMenu();
  const dispatch = useDispatch();
  const strings = useSelector(state => state.strings);

  const onSelectLanguage = (languageCode) => {
    dispatch(setLanguage(languageCode));
    close();
  };

  const dropButtonClass = isOpen ? 'fa-times' : 'fa-bars';
  return (
    <div className="ma-top-right">
      <h2 className="block-head" style={{ textTransform: 'none' }}>
        <span>
          {strings.languageSelection[strings.usingLanguage]}
        </span>
      </h2>
      <button
        className="ma-optns"
        onClick={onToggleOpenMenu}
        type="button"
      >
        <i className={`fa ${dropButtonClass}`} />
      </button>
      <div className="header-menu" style={{ maxHeight: isOpen ? '120px' : 0 }}>
        <button key="deutsch" onClick={() => onSelectLanguage('DE')} type="button">
          {strings.languageSelection.DE}
        </button>
        <button key="english" onClick={() => onSelectLanguage('EN')} type="button">
          {strings.languageSelection.EN}
        </button>
        <button key="spanish" onClick={() => onSelectLanguage('ES')} type="button">
          {strings.languageSelection.ES}
        </button>
      </div>
    </div>
  );
};


const CloseButton = ({ onClose }) => (
  <div className="ma-top-right">
    <button
      className="ma-optns"
      type="button"
      onClick={onClose}
    >
      <i className="fa fa-times" />
    </button>
  </div>
);

CloseButton.propTypes = {
  onClose: PropTypes.func.isRequired
};


const Header = ({ showMenus }) => {
  const history = useHistory();

  const onClose = () => {
    if (history.length > 2) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  const onHome = () => {
    // go home
    history.push('/');
  };

  return (
    <header className="header">
      <button
        type="button"
        onClick={onHome}
        className="logo-button"
      >
        <img src={logo} alt="Drager Logo" />
      </button>
      {
        showMenus ? (
          [
            <Route
              key="review"
              path="/review"
              render={() => (
                <ShareList />
              )}
            />,
            <Route
              key="license"
              path="/license"
              render={() => (
                <CloseButton onClose={onClose} />
              )}
            />,
            <Route
              key="licenses"
              path="/licenses"
              render={() => (
                <CloseButton onClose={onClose} />
              )}
            />,
            <Route
              key="title"
              path="/monitor"
              component={LanguageMenu}
            />,
            <Route
              key="home"
              exact
              path="/"
              component={LanguageMenu}
            />
          ]
        ) : (
          null
        )
      }
    </header>
  );
};

Header.defaultProps = {
  showMenus: true
};
Header.propTypes = {
  showMenus: PropTypes.bool
};

export default Header;
